import fetch from '@/utils/fetch'

// **********
// 角色相关
// **********

// 获取角色列表
export function getRolesList() {
  return fetch({
    url: '/shop/v1/roles',
    method: 'get'
  })
}

// 获取角色信息
export function getRole(id) {
  return fetch({
    url: `/shop/v1/roles/${id}`,
    method: 'get'
  })
}

// 新建角色
export function createRole(data) {
  return fetch({
    url: '/shop/v1/roles',
    method: 'post',
    data
  })
}

// 更新角色信息
export function updateRole(id, data) {
  return fetch({
    url: `/shop/v1/roles/${id}`,
    method: 'put',
    data
  })
}

// 删除角色
export function deleteRole(id) {
  return fetch({
    url: `/shop/v1/roles/${id}`,
    method: 'delete'
  })
}
